var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.fill ? 'position: relative; height: 100%;' : '')},[_c('canvas',{ref:"pieChart",class:{ 'chart-canvas-fill': _vm.fill }})])
}
var staticRenderFns = []

export { render, staticRenderFns }